import { type FinGroupName, getCategoryExperience } from '#dictionary'

import type FinancialRecord from './FinancialRecord'

/**
 * How many of a submission's child records fall in each FinGroup.
 *
 * Counts records rather than subtopics because a subtopic can span groups: the
 * charitable-goals `appreciatedStock` subtopic produces both a
 * `catExpensesCharity` and a `catIncomeOther` record. Counting subtopics per
 * group would report 6 for its 5 subtopics; every record belongs to exactly one
 * group, so counting records cannot double up.
 */
export type RecordsByGroup = Partial<Record<FinGroupName, number>>

export const countRecordsByGroup = (
  records: FinancialRecord[]
): RecordsByGroup =>
  records.reduce<RecordsByGroup>((counts, record) => {
    const group = getCategoryExperience(record.finCategory).finGroup
    counts[group] = (counts[group] ?? 0) + 1
    return counts
  }, {})
